import { render, staticRenderFns } from "./ChatDrawer.vue?vue&type=template&id=4087e571&scoped=true"
import script from "./ChatDrawer.vue?vue&type=script&lang=js"
export * from "./ChatDrawer.vue?vue&type=script&lang=js"
import style0 from "./ChatDrawer.vue?vue&type=style&index=0&id=4087e571&prod&lang=scss"
import style1 from "./ChatDrawer.vue?vue&type=style&index=1&id=4087e571&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4087e571",
  null
  
)

export default component.exports